<template>
	<div>
		
        <el-card class="box-card">
            <div style="display: flex;background: white">
                <div style="width: 50%;text-align: left;display: flex">
					<el-button type="primary" size="mini" @click="download">{{$t('getapi[6506]')}}</el-button>
                    <el-button type="primary" size="mini" @click="deleteAll">{{$t('getapi[686]')}}</el-button>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
							accept=".xlsx"
                            style="margin-left: 8px"
                    >
                        <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6507]')}}</el-button>
                    </el-upload>
                </div>
                <div style="width: 50%;text-align: right">
                    <el-button type="primary" size="mini" @click="save">{{$t('getapi[370]')}}</el-button>
                </div>
            </div>
        </el-card>
				<div id="xpane-0">
				<vxe-table :data="datajson"
				show-overflow
				ref='CloseSoTable'
				size="mini" :loading="loading"  :height="tableHeight" stripe border resizable>
					<vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
					<vxe-table-column show-footer-overflow field="Err_Msg" :title="$t('getapi[357]')" width="150px">
					</vxe-table-column>
					<vxe-table-column show-footer-overflow  field="Year" :title="$t('getapi[1974]')"></vxe-table-column>
					<vxe-table-column show-footer-overflow  field="Mouth" :title="$t('getapi[1975]')"></vxe-table-column>
					<vxe-table-column show-footer-overflow  field="Customer_Code" :title="$t('getapi[2987]')"></vxe-table-column>
					<vxe-table-column show-footer-overflow  field="Currency" :title="$t('getapi[8339]')"></vxe-table-column>
					<vxe-table-column field="Exchange_Rate" :title="$t('getapi[3287]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.Exchange_Rate | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column  field="Rec_Money" :title="$t('getapi[8451]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.Rec_Money | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column field="Accrue_Rate" :title="$t('getapi[12422]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.Accrue_Rate | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column field="Accrue_DiscountMoney" :title="$t('getapi[12432]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.Accrue_DiscountMoney | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column field="Accrue_SalMoney" :title="$t('getapi[12433]')" align="right">
						<template slot-scope="scope">
							{{ scope.row.Accrue_SalMoney | thousandth}}
						</template>
					</vxe-table-column>
					<vxe-table-column show-footer-overflow  field="Remark" :title="$t('getapi[143]')"></vxe-table-column>
				</vxe-table>
				</div>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import CommonHeader from '@/components/CommonHeader';
export default {
	name:'3_salmonthcountimp',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight-200
        }
    },
	data() {
		return {
			fileList: [],
			itevisible:false,
			ids: '',
			showloading: '',
			DbTbNames: '', //表名
			datajson: [],
			loading: false, // 主表加载状态
			uploadurl: '',
            scrollTop:0,
		};
	},
	created () {
		setTimeout(() => {
			this.datajson = [];
		}, 1000)
	},
	beforeMount() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		let token = JSON.parse(that.userData).token;
		that.uploadurl = Common.Url + '/Sal/SalDiscount/GetSal_Discount_RecTModelData?token=' + token;
		this.btnauthority();
	},
    watch: {
        datajson: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted() {
		console.log('mounted');
		this.btnauthority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.CloseSoTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.CloseSoTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		btnauthority() {
			let that = this;
		},
		deleteAll(){
			let that = this;
			let selectRecords = this.$refs.CloseSoTable.getCheckboxRecords();
			for(let i=selectRecords.length-1;i>=0;i--){
				let line = this.$refs.CloseSoTable.getRowIndex(selectRecords[i]);
				that.datajson.splice(line, 1);
			}
		},
		download(){
			let param={
					url:'/Sal/SalDiscount/GetSal_Discount_RecInfoTImportTemplat'
				}
				Array.methods.DownLoadTemp(param);
		},
		handleChange(file, fileList) {
			let that = this;
			that.loading = true;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
                    if(file.response.DataContent.Lists.length>0){
                        that.datajson = file.response.DataContent.Lists;
                    }else{
                        that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                    }
				}
				that.loading = false;
			}
		},
		handleSuccess(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
				that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
                if(res.DataContent.Lists.length>0){
                    that.datajson = res.DataContent.Lists;
                }else{
                    that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                }
			}
			that.fileList=[];
		},
		handleError(err, file, fileList) {
			let that = this;
			that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
		},
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
		handlePreview(file) {
			console.log("handlePreview"+file);
		},
		// 保存备注数据
		save() {
            let that = this;
            if(that.datajson.length==0){
                that.$message.warning(that.$t('getapi[8712]'));//'请添加导入数据！'
                return;
            }
            let parm = that.datajson
            that.$http.urlpost('/Sal/SalDiscount/SaveSal_Discount_RecTransaction', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                } else if(res.Success == 2){
                    that.datajson = res.DataContent.Lists
                }
            });
		},
	}
};
</script>

<style lang="scss" scoped>
span.label-fade-enter {
	font-size: medium;
	margin-right: 20px;
}
</style>
<style>
  .el-message-box {
    width: 600px;
  }
</style>
